import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      backgroundColor: COLORS.neutral.white,
      border: theme.shape.borderGray60,
      borderRadius: theme.shape.borderRadius,
      overflow: 'hidden',
    },
    tabs: {
      borderBottom: theme.shape.borderGray60,
    },
    tab: {
      textTransform: 'none' as const,
      minWidth: 'auto',
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 500,
    },
    badge: {
      backgroundColor: theme.palette.action.hover,
      borderRadius: 10,
      padding: '1px 6px',
      fontSize: theme.typography.pxToRem(10),
      fontWeight: 600,
      marginLeft: theme.spacing(0.75),
      color: theme.palette.text.secondary,
    },
    tableContainer: {
      maxHeight: 400,
    },
    headerCell: {
      fontWeight: 600,
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.text.secondary,
      backgroundColor: '#F9FAFB',
      borderRadius: '0 !important',
    },
    cell: {
      fontSize: theme.typography.pxToRem(13),
    },
    empty: {
      padding: theme.spacing(4),
      textAlign: 'center' as const,
      color: theme.palette.text.disabled,
      fontSize: theme.typography.pxToRem(13),
    },
  }),
  { name: 'DetailTables' }
);
